module.exports = __webpack_public_path__ + "img/arrow-long.fc3c19bf.svg";